import { useTranslation } from 'react-i18next'
import { Table, Input, Progress, Button, Pagination } from 'antd'
import '../assets/style/antTable.css'
import { FileDown } from 'lucide-react'

import ExcelButton from './ExcelButton'

// This is Main Components in the 90% Menus We use This Component The UI Of The Screens with table Is Here Only 9 Screens Don't Use This Component This are: 1.Reports,2.Cash => Balance,3.ProdWorkers,4.ProdWorkersDone,5.ProdWorkersAdmin 6.MySales 7.Debtors 8.DebtorsCheck 9.DashboardWorkers

function Header({
	title,
	currentPage,
	handlePreviousPage,
	handleNextPage,
	hasMoreData,
	columns,
	fdata,
	loading,
	handleRowClick,
	onBtnClick,
	onStartDateChange,
	onEndDateChange,
	startDate,
	endDate,
	formattedDate,
	isSticky = true,
	isPayVendor = false,
	onPayVendorClick,
	isPayEmployee = false,
	onPayEmployeeClick,
	scrollX = 900,
	onStartDueDateChange,
	onEndDueDateChange,
	startDueDate,
	endDueDate,
	rowKey = 'docEntry',
	addBtnCopy,
	isShowExcelBtn = false,
	handleDownloadExcel,
	loadingExcel = false,
	renderRightHeader = () => {},
	renderFiltersInBottom = () => {},
	renderFilters = () => {},
	tableProps = {},
	isShowPagination = false,
	handlePageSizeChange = () => {},
	handlePaginationChange = () => {},
	renderAddButtons = () => {},
}) {
	const { t } = useTranslation()

	return (
		<div className="m-5 border-[2px] border-gray-200">
			<div className="flex w-fullitems-center justify-between   ml-4 mr-4 mt-10 sm:ml-10 sm:mr-10 sm:mt-14 ">
				<h1 className="font-poppins text-xl font-bold text-black  sm:text-xl">
					{t(title)}
				</h1>
				<div className="flex items-center gap-5 flex-col sm:flex-row">
					{isPayVendor && (
						<button
							onClick={onPayVendorClick}
							className="h-[30px] w-auto py-1 px-3  bg-[#099204] rounded-lg text-white "
						>
							{t('payVendor')}
						</button>
					)}
					{isPayEmployee && (
						<button
							onClick={onPayEmployeeClick}
							className="h-[30px] w-auto py-1 px-3  bg-[#099204] rounded-lg text-white "
						>
							{t('payEmployee')}
						</button>
					)}
										{renderAddButtons && renderAddButtons()}

					{onBtnClick && (
						<button
							onClick={onBtnClick}
							className="h-[30px] w-[140px]  bg-[#099204] rounded-lg text-white "
						>
							{t('Add')}
						</button>
					)}
					{addBtnCopy && (
						<button
							onClick={addBtnCopy}
							className="h-[30px] w-[140px]  bg-[#099204] rounded-lg text-white "
						>
							{t('addCopy')}
						</button>
					)}
					{isShowExcelBtn && (
						<ExcelButton
							handleDownloadExcel={handleDownloadExcel}
							loadingExcel={loadingExcel}
						/>
					)}
				</div>
			</div>

			<div className="mt-8 w-full border-[1px] border-[#E8E8E8] sm:mt-8"></div>

			<div className="flex w-full flex-col sm:flex-row items-end justify-between gap-4 px-4  sm:gap-7 sm:px-10 mt-5 ">
				{onEndDateChange ? (
					<div className=" flex gap-5 flex-col items-end sm:flex-row">
						<div className="flex flex-col gap-2">
							<p>{t('startDate')}</p>
							<Input
								type="date"
								value={startDate}
								className="w-[150px] h-8"
								onChange={onStartDateChange}
								max={endDate}
								allowClear
							/>
						</div>
						<div className="flex flex-col gap-2">
							<p>{t('endDate')}</p>
							<Input
								type="date"
								value={endDate}
								className="w-[150px] h-8"
								onChange={onEndDateChange}
								min={startDate}
								max={formattedDate}
								allowClear
							/>
						</div>
			{renderFilters && renderFilters()}
					</div>
				) : (
					renderFilters && renderFilters()
				)}

				{onStartDueDateChange && (
					<div className=" flex gap-5 flex-col sm:flex-row">
						<div className="flex flex-col gap-2">
							<p>{t('startDueDate')}</p>
							<Input
								type="date"
								value={startDueDate}
								className="w-[150px]"
								onChange={onStartDueDateChange}
								max={endDueDate}
								allowClear
							/>
						</div>
						<div className="flex flex-col gap-2">
							<p>{t('endDueDate')}</p>
							<Input
								type="date"
								value={endDueDate}
								className="w-[150px]"
								onChange={onEndDueDateChange}
								min={startDueDate}
								max={formattedDate}
								allowClear
							/>
						</div>
					</div>
				)}
				{renderRightHeader && renderRightHeader()}
			</div>

			<div className="mt-6 sm:ml-10 sm:mt-10">
				{handleNextPage ? (
					<div className="mb-4 flex flex-col justify-between sm:flex-row">
						{renderFiltersInBottom && renderFiltersInBottom()}
						<div className="font-nunitto font-bold">{''}</div>

						<div className="mt-2 flex sm:mr-10">
							<button
								onClick={handlePreviousPage}
								disabled={currentPage === 1}
								className="h-[30px] w-[110px] bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 "
							>
								{t('previous')}
							</button>
							<div className="bg-[#099204]  w-[20px] h-[30px] flex items-center  justify-center">
								<span className="text-center text-white">
									{currentPage}
								</span>
							</div>
							<button
								onClick={handleNextPage}
								disabled={!hasMoreData}
								className="h-[30px] w-[110px] bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 "
							>
								{t('next')}
							</button>
						</div>
					</div>
				) : renderFiltersInBottom ? (
					<>{renderFiltersInBottom && renderFiltersInBottom()}</>
				) : null}

				{isShowPagination && (
					<div className="flex justify-end mr-10 mt-5 mb-5">
						<Pagination
							showTotal={(total) =>
								t('totalPaginationItems', { total })
							}
							showSizeChanger={true}
							current={currentPage}
							onShowSizeChange={(pageSize, current) => {
								handlePageSizeChange(current, pageSize)
							}}
							total={fdata[0]?.documentsCount || 0} // ✅ correct
							pageSize={fdata[0]?.pageSize || 10}
							onChange={(page, pageSize) => {
								handlePaginationChange(page, pageSize)
							}}
							// locale={{
							// 	items_per_page: ' / Страница',
							// 	jump_to: 'Перейти',
							// 	jump_to_confirm: 'OK',
							// 	page: 'Страница', // 👈 change this
							// 	prev_page: 'Предыдущая',
							// 	next_page: 'Следующая',
							// }}
						/>
					</div>
				)}

				<div className="mr-10 mt-10 mb-10">
					<Table
						columns={columns}
						dataSource={fdata}
						pagination={false}
						bordered
						className="w-full"
						rowKey={rowKey}
						scroll={{ x: scrollX }}
						loading={loading}
						{...(handleRowClick && {
							onRow: (record) => ({
								onClick: () => handleRowClick(record),
							}),
						})}
						{...(isSticky && {
							sticky: false,
						})}
						{...(tableProps && tableProps)}
					/>
				</div>
			</div>
		</div>
	)
}
export default Header
